import React, { Component, Fragment } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { IWebinarsProps } from '../../../interfaces/props/IWebinarDetailsProps';
import * as dateHelpers from '../../../helpers/date.helpers';
import { webinarsService } from '../../../services';
import ReactPlayer from 'react-player';
import { IWebinarLog } from '../../../common/model/webinar.model';
import moment from 'moment';
import './webinar.scss';

type WebinarsPropsType = IWebinarsProps & RouteComponentProps & WithTranslation;

class Webinar extends Component<WebinarsPropsType> {
  private readonly videoPlayer = React.createRef<ReactPlayer>();

  public async onPlay(webinarId: string): Promise<void> {
    const {
      userId,
      companyId
    } = this.props;

    if (companyId !== undefined && companyId != null) {
      const webinarLog: IWebinarLog = { webinarId: webinarId, userId: userId, companyId: companyId, date: moment() };

      webinarsService.createLog(webinarLog)
        .then(() => console.log(`Log Registered to Webinar Id=[${webinarId}]`))
        .catch((err) => console.error(`Error to Log Registered to Webinar Id=[${webinarId}]. Error: ${err}`));
    }
  }

  public render() {
    const { webinar, isEven, i18n } = this.props;

    const info = <div key={'info_' + webinar.id} className={'column info ' + (isEven ? 'isEven' : 'isOdd')}>
      <p>
        <span className='date'>{dateHelpers.toLongDate(webinar.date)}</span>
        <br></br>
        <span className='name'>{webinar.name}</span>
      </p>
      <p><span className='speakers'>{' > '}</span>{i18n.t('webinar.speakers')}: {webinar.speakers}</p>
      <div>{webinar.description}</div>
    </div>;

    const video = <div key={'video_' + webinar.id} className={'column video ' + (isEven ? 'isEven' : 'isOdd')}>
      <ReactPlayer
        url={webinar.videoUrl}
        ref={this.videoPlayer}
        onPlay={(): Promise<void> => this.onPlay(webinar.id)}
        controls={true}
        // Disable download button
        config={{ file: { attributes: { controlsList: 'nodownload' } } }}
        // Disable right click
        onContextMenu={(e: any) => e.preventDefault()}
        light={'https://aitextextranetstrgpro.blob.core.windows.net/webinar/thumbnail-webinar.png'}
      />
    </div>;

    const item: JSX.Element[] = [];

    if (isEven) {
      item.push(video);
      item.push(info);
    } else {
      item.push(info);
      item.push(video);
    }

    return (<Fragment>
      <div id={webinar.id} className={'row ' + (isEven ? 'isEven' : 'isOdd')} style={{ margin: '2%' }}>
        {item}
      </div>

      <hr />
    </Fragment>
    );
  }
}

export default withRouter(withTranslation()(Webinar));
